export const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: {
        delay: i * 0.05,
        duration: 0.5,
        ease: "easeOut" as const,
        },
    }),
};